import React from 'react'

export default function BorderRadiusTopRight({ color = '#7246B1', style = {} }) {
    return (
        <svg
            className='icons-icon'
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M9 4H13C14.6569 4 16 5.34315 16 7V11' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
